import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './TollFreeTermination.css';

const TollFreeTermination = () => {
  return (
    <div className="tollfreetermination-container">
      {/* Hero Section */}
      <section className="tollfreetermination-hero">
        <motion.div 
          className="tollfreetermination-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="tollfreetermination-hero-title">Toll-Free Termination</h1>
          <h2 className="tollfreetermination-hero-subtitle">
            Seamless Toll-Free Connectivity with Superior Voice Quality
          </h2>
          <Link to="/contact" className="tollfreetermination-cta-btn">
            <motion.button
              className="tollfreetermination-cta-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Get Started
            </motion.button>
          </Link>
        </motion.div>
      </section>

      {/* Main Content */}
      <section className="tollfreetermination-content">
        <div className="tollfreetermination-content-container">
          <motion.div 
            className="tollfreetermination-intro"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="tollfreetermination-section-text">
              Welcome to DirectRoutes Networks' Toll-Free Termination Service, where global connectivity meets exceptional voice quality, low-latency routing, and carrier-grade reliability.
            </p>
          </motion.div>

          <motion.div 
            className="tollfreetermination-main-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <p className="tollfreetermination-section-text">
              We understand the crucial role toll-free communication plays in today's business environment. Our solutions support both domestic and international 8YY traffic, ensuring seamless voice delivery with industry-leading performance and full regulatory compliance.
            </p>
          </motion.div>

          <motion.div 
            className="tollfreetermination-compensation-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <h2 className="tollfreetermination-section-title">Compensation for Termination Services</h2>
            <p className="tollfreetermination-section-text">
              At DirectRoutes Networks, we value every minute of traffic you route through our toll-free termination service. Partnering with top-tier carriers, we provide reliable routing and competitive compensation for every qualifying minute. Our volume-based payout model rewards you as your traffic grows, maximizing the profitability of your toll-free operations.
            </p>
          </motion.div>

          <motion.div 
            className="tollfreetermination-conclusion"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <p className="tollfreetermination-section-text">
              Beyond connectivity, we offer transparent reporting, timely payments, and responsive support, helping telecom carriers, VoIP providers, and call aggregators fully leverage their toll-free traffic. With DirectRoutes Networks, you gain a termination solution built for both performance and profitability.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TollFreeTermination;
